import { useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
import { Input, Button } from "antd";

function TagsInput({ values, handleChange }) {
  const [tag, setTag] = useState("");
  const [error, setError] = useState(false);

  const agregarEtiqueta = () => {
    if (tag === "") return;
    const email = tag.trim();
    handleChange("emails", [...values.emails, email]);
    setTag("");
  };

  function removeTag(index) {
    const newTags = [...values.emails];
    newTags.splice(index, 1);
    handleChange("emails", newTags);
  }

  const handleChangeTag = (e) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(e.target.value) && e.target.value !== "") {
      setError(true);
    } else {
      setError(false);
    }
    setTag(e.target.value);
  };

  return (
    <>
      <div className="mb-2">
        <Input
          placeholder="Escribe y presiona +"
          style={{ width: "160px", marginRight: "10px" }}
          value={tag}
          onChange={handleChangeTag}
        />
        <Button
          onClick={agregarEtiqueta}
          type="default"
          variant="solid"
          color="default"
          icon={<PlusOutlined />}
          disabled={error || tag === ""}
        ></Button>

        {error && <div style={{ color: "red" }}>E-mail inválido!</div>}
      </div>

      <div className="tags-input-container">
        {values?.emails?.map((tag, index) => (
          <div className="tag-item" key={index}>
            <span>{tag}</span>
            <span className="close" onClick={() => removeTag(index)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </span>
          </div>
        ))}
      </div>
    </>
  );
}

export default TagsInput;
